module.exports = __webpack_public_path__ + "static/shieldwear-6d902d20a6a4e1eda4db41cae5e05fc4.svg";